import { brandingImporter } from '@sbx/prec-shared-utils';

/**
 * Maps the provided context to the headers needed by the search API
 * @param {string} searchText
 */

export async function fetchProducts(searchText, hasPimIds = true) {
  const { searchURLHeaders, searchURL } = brandingImporter();

  const searchAPI = hasPimIds ? '/api/list/buyer/box/' : '/api/search/buyer/box?';

  const url = new URL(`${window.location.protocol}//${searchURL}${searchAPI}${searchText}`);

  const response = await fetch(url.toString(), {
    headers: searchURLHeaders,
  });

  const jsonResponse = await response.json();
  return jsonResponse;
}
